import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LeavesRoutingModule } from './leaves-routing.module';
import { LeavesDetailsComponent } from './components/leaves-details/leaves-details.component';
import { LeavesViewComponent } from './components/leaves-view/leaves-view.component';
import { LeavesComponent } from './leaves.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { LeaveCreateComponent } from './components/leave-create/leave-create.component';
import { LeavesStatusComponent } from './components/leaves-status/leaves-status.component';


@NgModule({
  declarations: [LeavesDetailsComponent, LeavesViewComponent, LeavesComponent, LeaveCreateComponent,LeavesStatusComponent],
  imports: [
    CommonModule,
    LeavesRoutingModule,
    SharedModule
  ]
})
export class LeavesModule { }
